import {
  Stack,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Button,
  IconButton,
} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ReactQuill from "react-quill";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import { StyledDropzone } from "../../../shared/components/StyledDropzone";

export default function StepsSection({
  tipsAndTricks,
  handleDragEnd,
  handleDropzone,
  removeImage,
  handleStepChange,
  stepsHandleDelete,
  addStepChangeHandler,
  modules,
  formats,
}) {
  const data = tipsAndTricks?.data?.steps || [
    {
      step: "",
      image_url: "",
      imageFile: "",
      loading: false,
    },
  ];

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="stepsDroppable">
        {(provided) => (
          <TableContainer
            component={Paper}
            {...provided.droppableProps}
            ref={provided.innerRef}
            sx={{
              backgroundColor: "#F5F8FC",
              borderRadius: 0,
              boxShadow: "none",
            }}
          >
            <Table
              aria-label="steps table"
              sx={{ mx: "8px", mb: "8px", width: "calc(100% - 16px)" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Image</TableCell>
                  <TableCell>Steps</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>

              <TableBody sx={{ border: 1, borderColor: "divider" }}>
                {data?.length > 0 ? (
                  data.map((row, index) => (
                    <Draggable
                      key={index.toString()}
                      draggableId={index.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <TableRow
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            backgroundColor: snapshot.isDragging
                              ? "#f0f0f0"
                              : "inherit",
                            ...provided.draggableProps.style,
                          }}
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                          }}
                        >
                          <TableCell {...provided.dragHandleProps}>
                            <DragIndicatorIcon
                              sx={{
                                cursor: "grab",
                                alignSelf: "center",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <StyledDropzone
                              maxFiles={1}
                              loading={row?.loading}
                              handleDropzone={(e) => handleDropzone(e, index)}
                              imgUrl={
                                row?.imageFile
                                  ? URL.createObjectURL(row.imageFile)
                                  : row?.image_url || ""
                              }
                              removeImage={() => removeImage(index)}
                            />
                          </TableCell>
                          <TableCell>
                            <ReactQuill
                              theme="snow"
                              style={{ minWidth: "100%" }}
                              modules={modules}
                              formats={formats}
                              value={row.step}
                              onChange={(value) =>
                                handleStepChange(value, index)
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <IconButton
                              sx={{
                                color: "#B42318",
                                cursor: "pointer",
                              }}
                              onClick={() => stepsHandleDelete(index)}
                              disabled={row?.loading}
                            >
                              <RemoveCircleIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      )}
                    </Draggable>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                      <Stack alignItems="center" gap="8px">
                        <img
                          src={emptyIcon}
                          alt="empty"
                          height={56}
                          width={56}
                        />
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#485364",
                          }}
                        >
                          No data found
                        </Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                )}
                {provided.placeholder}
              </TableBody>

              <TableFooter
                sx={{
                  backgroundColor: "#FFFFFF",
                  border: 1,
                  borderColor: "divider",
                }}
              >
                <TableRow>
                  <TableCell colSpan={4}>
                    <Button
                      type="button"
                      size="small"
                      variant="text"
                      startIcon={<AddIcon />}
                      onClick={addStepChangeHandler}
                    >
                      Add Step
                    </Button>
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
      </Droppable>
    </DragDropContext>
  );
}
